import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  Button,
  ContentSection,
  InstructionStepper,
  Layout,
  Paragraph,
  SectionHeading,
  TileSelect,
  TileSelectGroup,
} from '@vwfs-bronson/bronson-react';
import { sendIdentProcessEmail } from '../../services/api/ident/sendIdentProcessEmail';
import { creditApplicationSelectors } from '../../services/redux/features/creditApplication.slice';
import { useNavigate } from '../../services/routing/navigate';

interface Props {
  formData?: any;
}

export const IdentSuccessForPAWithCoApplicantPage: FunctionComponent<Props> = () => {
  const { t } = useTranslation();
  const [identProcessType, setIdentProcessType] = useState('');
  const navigate = useNavigate();
  const { applicantCreditScoreIdCoCustomer } = useSelector(creditApplicationSelectors.selectCreditApplicationIds)!;

  enum IdentProcessOptions {
    EMAIL = 'email',
    SCRIVE = 'scrive',
  }

  const navigateToNextPage = async (): Promise<void> => {
    if (identProcessType === IdentProcessOptions.EMAIL) {
      sendIdentProcessEmail();
      navigate.form('/5');
    } else {
      navigate.identLandingCoApplicant();
    }
  };

  const isSignatory = !applicantCreditScoreIdCoCustomer;

  return (
    <>
      <ContentSection pageWrapSize="small">
        <SectionHeading level={3}>{t('identSuccessPage:PAWithCoApplicantPage:title')}</SectionHeading>
        <Layout center>
          <Layout.Item>
            <Paragraph>
              {isSignatory
                ? t('identSuccessPage:PAWithCoApplicantPage:subtitleSignatory')
                : t('identSuccessPage:PAWithCoApplicantPage:subtitle')}
            </Paragraph>
          </Layout.Item>
        </Layout>
        <TileSelectGroup layoutItemClassName="u-1/2 u-1/1@s" title={{ text: '' }}>
          <TileSelect
            value={IdentProcessOptions.EMAIL}
            checked={identProcessType === IdentProcessOptions.EMAIL}
            title=""
            inputType="radio"
            radioGroupName="identProcessOption"
            onChange={() => {
              setIdentProcessType(IdentProcessOptions.EMAIL);
            }}
          >
            {isSignatory
              ? t('identSuccessPage:PAWithCoApplicantPage:checkboxOptions:emailSignatory')
              : t('identSuccessPage:PAWithCoApplicantPage:checkboxOptions:email')}
          </TileSelect>

          <TileSelect
            value={IdentProcessOptions.SCRIVE}
            checked={identProcessType === IdentProcessOptions.SCRIVE}
            title=""
            inputType="radio"
            radioGroupName="identProcessOption"
            onChange={() => {
              setIdentProcessType(IdentProcessOptions.SCRIVE);
            }}
          >
            {isSignatory
              ? t('identSuccessPage:PAWithCoApplicantPage:checkboxOptions:scriveSignatory')
              : t('identSuccessPage:PAWithCoApplicantPage:checkboxOptions:scrive')}
          </TileSelect>
        </TileSelectGroup>
      </ContentSection>
      <ContentSection>
        <Layout center>
          <Layout.Item default="1/3">
            <Button type="button" full onClick={() => navigateToNextPage()} disabled={identProcessType === ''}>
              {t('identSuccessPage:next')}
            </Button>
          </Layout.Item>
        </Layout>
      </ContentSection>
      <ContentSection pageWrap pageWrapSize="medium">
        <InstructionStepper
          statusActiveText={t('app:instructionStepper:activeLabel')}
          statusNotActiveText={t('app:instructionStepper:nonActiveLabel')}
        >
          <InstructionStepper.Step icon="document" title={t('identSuccessPage:instructions:upload')} />
          <InstructionStepper.Step
            icon="checkmark"
            state="is-active"
            title={t('identSuccessPage:instructions:analysis')}
          />
          <InstructionStepper.Step icon="pen" title={t('identSuccessPage:instructions:sign')} />
          <InstructionStepper.Step icon="semantic-calendar" title={t('identSuccessPage:instructions:vehicle')} />
        </InstructionStepper>
      </ContentSection>
    </>
  );
};
